//import Vue from 'vue'

const state = {
}

const getters = {
    status2variant(state) {
        return (status) => {
            const table = {
                'activated': 'success',
                'suspended': 'dark',
                //'listed': 'info',
                //'sold': 'danger',
                //'': 'warning',
            }
            return table[status]
        }
    },
    is_public2variant(state) {
        return (is_public) => {
            const table = {
                false: 'dark',
                true: 'warning',
            }
            return table[is_public]
        }
    },
}

const mutations = {
}

const actions = {
    async search (context, data) {
        const response = await axios.get('/api/v1/item_categories/search/', {
            params: {
                provider: (typeof data === 'object' ? data.provider : null),
                query: (typeof data === 'object' ? data.query : null),
            },
        })
            .catch(error => error.response || null)
        return response
    },
    async options (context, data) {
        const response = await axios.get('/api/v1/item_categories/options/', {
            params: {
                provider: (typeof data === 'object' ? data.provider : null),
                category_id: (typeof data === 'object' ? data.category_id : null),
            },
        })
            .catch(error => error.response || null)
        return response
    },
/*
    async show (context, uuid) {
        const response = await axios.get('/api/v1/i/' + uuid)
            .catch(error => error.response || null)
        return response
    },
    async answer (context, data) {
        const response = await axios.post('/api/v1/i/' + data.form_uuid + (data.answer_uuid ? '/' + data.answer_uuid : ''), data)
            .catch(error => error.response || null)

        return response
    },
    async favorite (context, data) {
        const response = await axios.post('/api/v1/items/' + data.uuid + '/favorite')
            .catch(error => error.response || null)
        return response
    },
    async status (context, data) {
        const response = await axios.put('/api/v1/items/' + data.uuid + '/status', data)
            .catch(error => error.response || null)
        return response
    },
    async download (context, data) {
        data = Object.assign(data, { download: true, })
        const response = await axios.get('/api/v1/items', {
            params: (typeof data === 'object' ? data : null),
            responseType: 'blob',
            dataType: 'binary',
            headers: { 'Cache-Control': 'no-cache' },
        })
        .catch(error => error.response || null)
        Vue.prototype.download(response)
        return response
    },
    async list_item (context, data) {
        const response = await axios.post('/api/v1/items/' + data.uuid + '/list_item/' + data.provider, data)
            .catch(error => error.response || null)

        return response
    },
*/
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}

